export enum LocationTypes {
  Intersection = 'Intersection',
  Area = 'Area',
  Ramp = 'Ramp',
  Detour = 'Detour',
}
